import { supabase } from "../supabaseClient"

const invoke = async (body) => {
  const { data, error } = await supabase.functions.invoke("measurement-documentation", { body })
  if (error) {
    let payload = null
    if (error.context?.json) {
      try { payload = await error.context.json() } catch (_) {
        // Keep the function client's message when the response is not JSON.
      }
    }
    const requestError = new Error(payload?.error || error.message || "Measurement documentation request failed")
    requestError.code = payload?.code || null
    requestError.details = payload?.details || null
    throw requestError
  }
  if (data?.error) {
    const requestError = new Error(data.error)
    requestError.code = data.code || null
    requestError.details = data.details || null
    throw requestError
  }
  return data || {}
}

export const listMeasurementDocumentation = (organizationId, accountId) => invoke({
  action: "list", organization_id: organizationId, account_id: accountId,
})

export const startMeasurementOAuth = (organizationId, accountId, purpose = "read", connectionId = null) => invoke({
  action: "oauth-start", organization_id: organizationId, account_id: accountId,
  purpose, connection_id: connectionId,
})

export const completeMeasurementOAuth = (organizationId, code, state) => invoke({
  action: "oauth-complete", organization_id: organizationId, code, state,
})

export const discoverMeasurementResources = (organizationId, connectionId) => invoke({
  action: "discover", organization_id: organizationId, connection_id: connectionId,
})

export const saveDomainMeasurementMapping = (organizationId, values) => invoke({
  action: "save-mapping", organization_id: organizationId, ...values,
})

export const importLiveMeasurementDocumentation = (organizationId, mappingId) => invoke({
  action: "import-live", organization_id: organizationId, mapping_id: mappingId,
})

export const saveMeasurementDraft = (organizationId, revisionId, spec) => invoke({
  action: "save-draft", organization_id: organizationId, revision_id: revisionId, spec,
})

export const adoptMeasurementResources = (organizationId, mappingId, revisionId, resources) => invoke({
  action: "adopt", organization_id: organizationId, mapping_id: mappingId,
  revision_id: revisionId, resources,
})

export const reviewMeasurementDocumentation = (organizationId, revisionId) => invoke({
  action: "review", organization_id: organizationId, revision_id: revisionId,
})

export const preflightMeasurementDocumentation = (organizationId, revisionId) => invoke({
  action: "preflight", organization_id: organizationId, revision_id: revisionId,
})

export const createMeasurementGtmVersion = (organizationId, revisionId) => invoke({
  action: "create-version", organization_id: organizationId, revision_id: revisionId,
})

export const publishMeasurementGtmVersion = (organizationId, syncRunId) => invoke({
  action: "publish", organization_id: organizationId, sync_run_id: syncRunId,
})
